import { withAlertHandler } from 'entoro-shared';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import Dialog, {
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
} from 'material-ui/Dialog';
import Button from 'material-ui/Button';
import OfferActionDialog from '../../OfferActionDialog';

class ReadyToInvestAction extends Component {
  state = {
    displayDialog: false,
  };

  handleDialogClose = () => {
    this.setState({ displayDialog: false });
  };

  request = async ({ message }) => {
    const {
      client,
      handleSnackbarError,
      offerId,
      mutation,
      refetchQueries,
      handleClose,
      toggleConfirmDialog,
    } = this.props;
    const { mutate } = client;

    const variables = {
      offerId,
      message,
    };

    try {
      await mutate({ mutation, variables, refetchQueries });

      handleClose();
      toggleConfirmDialog();
    } catch (error) {
      handleClose();
      let errorObj = { error };
      if (
        errorObj.error.graphQLErrors[0].message ==
        'Your KYC is still being processed. Please check back later or contact your admin msills@entoro.com '
      ) {
        this.setState({ displayDialog: true });
      } else {
        handleSnackbarError(error);
      }
    }
  };

  render() {
    const {
      title,
      dialogBody,
      disabled,
      open,
      handleClickOpen,
      handleClose,
      acuantKyc,
    } = this.props;

    return (
      <Fragment>
        <Dialog open={this.state.displayDialog}>
          <DialogContent>
            <DialogTitle>KYC Verification Status</DialogTitle>
            <DialogContentText>
              Your KYC is still being processed. Please check back later or
              contact your admin
              <br />
              <br />
              <a href={`mailto:msills@entoro.com`}> msills@entoro.com</a>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDialogClose} className='action-button'>
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <OfferActionDialog
          open={open}
          disabled={disabled}
          handleClose={handleClose}
          request={this.request}
          title={title}
          dialogBody={dialogBody}
          enableMessage={false}
          acuantKyc={acuantKyc}
          submitText='Submit'
        />
        <button
          onClick={handleClickOpen}
          className='button small w-button'
          style={{ width: 'inherit' }}
        >
          {title}
        </button>
      </Fragment>
    );
  }
}

ReadyToInvestAction.propTypes = {
  client: PropTypes.object.isRequired,
  handleSnackbarError: PropTypes.func.isRequired,
  offerId: PropTypes.string.isRequired,
  mutation: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  dialogBody: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    .isRequired,
  refetchQueries: PropTypes.array,
  disabled: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  handleClickOpen: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
};

ReadyToInvestAction.defaultProps = {
  refetchQueries: [],
  disabled: false,
};

export default connect()(withApollo(withAlertHandler(ReadyToInvestAction)));



// WEBPACK FOOTER //
// ./src/components/OfferOverview/ReadyToInvestButton/ReadyToInvest/ReadyToInvestAction.js